import { useEffect, useState } from "react";
import { api } from "../api/client";

export function useOpciones(resource: string, etiqueta: (item: any) => string, filtro?: (item: any) => boolean) {
  const [opciones, setOpciones] = useState<{ value: string; label: string }[]>([]);
  const [raw, setRaw] = useState<any[]>([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let activo = true;
    setCargando(true);
    api
      .get(resource, { params: { porPagina: 200 } })
      .then((res) => {
        if (!activo) return;
        const items: any[] = res.data.items ?? [];
        const filtrados = filtro ? items.filter(filtro) : items;
        setRaw(filtrados);
        setOpciones(filtrados.map((it) => ({ value: it.id, label: etiqueta(it) })));
      })
      .finally(() => activo && setCargando(false));
    return () => {
      activo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resource]);

  return { opciones, raw, cargando };
}
